import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  validateDestinationCard: (input) => ({
    url: 'cardTransfer/api/v1/transaction/melli/destination/account/inquiries',
    method: 'POST',
    data: input,
  }),
  getTransferTypes: (input) => ({
    url: 'cardTransfer/api/v1/transaction/melli/transferTypes',
    method: 'POST',
    data: input,
  }),
  sendPasswordOtp: (input) => ({
    url: 'cardTransfer/api/v1/transaction/melli/send/otp',
    method: 'POST',
    data: input,
  }),
  getTransferReasons: (input) => ({
    url: 'cardTransfer/api/v1/transaction/melli/transferReasons',
    method: 'POST',
    data: input,
  }),
  transfer: (input) => ({
    url: 'cardTransfer/api/v1/transaction/melli/transfer',
    method: 'POST',
    data: input,
  }),
  getContract: () => ({
    url: 'card/api/v1/contract',
    method: 'GET',
  }),
  getCreateAccountStatus: () => ({
    url: 'card/api/v1/accounts/create',
    method: 'POST',
  }),
  setNationalCardInfo: (input) => ({
    url: 'card/api/v1/accounts/nationalCardInfo',
    method: 'POST',
    data: input,
  }),
  getSavedCards: () => ({
    url: 'cardTransfer/api/v1/transaction/melli/destinationAccounts',
    method: 'GET',
  }),
  addToSavedCards: (input) => ({
    url: 'cardTransfer/api/v1/transaction/destinationAccounts',
    method: 'POST',
    data: input,
  }),
  removeSavedCard: (input) => ({
    url: 'cardTransfer/api/v1/transaction/melli/destinationAccount/remove',
    method: 'PUT',
    data: input,
  }),
  sendAccountIssueOtp: () => ({
    url: 'card/api/v1/contract/otp',
    method: 'POST',
  }),
  getMelliCardAccountInquiry: () => ({
    url: 'card/api/v1/accounts/inquiry',
    method: 'GET',
  }),
  getMelliCardSourceAccounts: () => ({
    url: 'cardTransfer/api/v1/transaction/melli/sourceAccount',
    method: 'GET',
  }),
  getMelliCardTransactions: (input) => ({
    url: 'cardTransfer/api/v1/transaction/melli/report',
    method: 'GET',
    params: input,
  }),
  getMelliCardTransactionById: (input) => ({
    url: `cardTransfer/api/v1/transaction/melli/report/${input?.id}`,
    method: 'GET',
  }),
  inquireMelliCardTransaction: (input) => ({
    url: `cardTransfer/api/v1/transaction/melli/inquiry`,
    method: 'POST',
    data: input,
  }),
  getMelliCardEligibility: () => ({
    url: 'card/api/v1/accounts/checkEligibility',
    method: 'GET',
  }),
};

export default apis;
